import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common'

@Component({
	standalone: true,
	selector: 'app-intro-banner',
	templateUrl: 'intro-banner.component.html',
	styleUrls: ['intro-banner.component.scss'],
	imports: [NgOptimizedImage],
})
export class IntroBannerComponent {
	loading: boolean = true;

	@Input({ required: true })
	imageUrl: string;
}
